import React from "react";
import { TitleText } from "../../components/titleText";
import { TitleTextInput } from "../../components/titleTextInput";
import { Step } from "../../components/step";
import { Condition } from "../../components/condition";
import { TitleTextRich } from "../../components/titleTextRich";
import { TitleCheckboxsComponent } from "../../components/titleCheckboxs";
import { Expense } from "../../components/expense";
import Margin from "canvas-core-react/lib/Margin";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import { ScotiamanAvatar } from "../../components/scotiamanAvatar";
import { IncomeOutcomeComponent } from "../../components/graph/income";
import { SavingComponent } from "../../components/graph/saving";
import { ConditionSystem } from "../../components/condition-system";
import { DownloadPDF } from "../../components/download-pdf";
import { EndCoach } from "../../components/endCoach";

interface GetComponentProps {
  name: string;
  type: string;
  title: string;
  contenido: string;
  inputs: {
    name: string;
    title: string;
    group?: string;
    subGroup?: string;
  }[];
  typeValue?: string;
  tag?: any;
  contenidoArray?: string[];
  videoName?: string;
  options?: string[];
  checkboxs?: string[];
  steps?: any[];
  stepNumber?: number;
  onClickParent?: any;
  indexComponent?: any;
  specialButton?: boolean;
}

export const getComponent = ({
  name,
  title,
  contenido,
  inputs = [],
  typeValue = "",
  tag,
  contenidoArray = [],
  videoName = "",
  options = [],
  checkboxs = [],
  steps = [],
  stepNumber = 0,
  onClickParent,
  indexComponent = 0,
  specialButton = false,
}: GetComponentProps) => {
  switch (name) {
    case "step":
      return <Step steps={steps} step={stepNumber} />;
    case "condition":
      return addMarginCondition(
        <Condition
          options={options}
          onClickParent={onClickParent}
          step={stepNumber}
          tag={tag}
          indexComponent={indexComponent}
        />
      );
    case "condition-system":
      return addMarginCondition(
        <ConditionSystem
          options={options}
          onClickParent={onClickParent}
          step={stepNumber}
        />
      );
    case "title-text":
      return addMargin(<TitleText title={title} content={contenido} />);
    case "title-text-input":
      return addMargin(
        <TitleTextInput
          title={title}
          content={contenido}
          inputs={inputs}
          typeValue={typeValue}
          onClickParent={onClickParent}
          step={stepNumber}
          index={indexComponent}
          specialButton={specialButton}
          tag={tag}
        />
      );
    case "title-text-rich":
      return addMargin(
        <TitleTextRich title={title} contenido={contenidoArray} />
      );

    case "title-checkboxs":
      return addMargin(
        <TitleCheckboxsComponent title={title} checkboxs={checkboxs} />
      );
    case "add-input":
      return addMargin(
        <Expense
          title={title}
          contenido={contenido}
          onClickParent={onClickParent}
          step={stepNumber}
          index={indexComponent}
          tag={tag}
        />
      );
    case "report1":
      return addMargin(<IncomeOutcomeComponent />);
    case "report2":
      return addMargin(<SavingComponent />);
    case "title-pdf":
      return addMargin(<DownloadPDF />);
    case "end":
      return addMargin(<EndCoach />);
    default:
  }
};
const addMargin = (children: any) => {
  return (
    <div className="component">
      <Margin xs={48} sm={48} md={48} lg={48}>
        <Margin xs={18} sm={18} md={18} lg={18}>
          <Row>
            <Column xs={1} sm={1} md={1} lg={1}>
              <ScotiamanAvatar />
            </Column>
            <Column xs={3} sm={7} md={10} lg={10}>
              {children}
            </Column>
          </Row>
        </Margin>
      </Margin>
    </div>
  );
};
const addMarginCondition = (children: any) => {
  return (
    <div className="component">
      <Margin xs={48} sm={48} md={48} lg={48}>
        <Margin xs={18} sm={18} md={18} lg={18}>
          <Row>
            <Column xs={1} sm={1} md={1} lg={1}></Column>
            <Column xs={3} sm={7} md={11} lg={11}>
              {children}
            </Column>
          </Row>
        </Margin>
      </Margin>
    </div>
  );
};
